"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const steps = [{
  id: "01",
  title: "諮詢預約",
  description: "您可以透過電話或網上表格與我們聯繫，專業顧問會初步了解您的家庭護理需求、期望目標及目前的健康狀況。"
}, {
  id: "02",
  title: "專業評估",
  description: "由資深護士或治療師親自上門，詳細評估服務使用者的身體機能、家居環境及心理需要，確保照護方案全面到位。"
}, {
  id: "03",
  title: "制定計劃",
  description: "根據評估結果，量身訂造個人化復康及護理計劃，並精準匹配最合適的醫護專業團隊，落實各項細節安排。"
}, {
  id: "04",
  title: "開始護理",
  description: "護理人員正式提供到戶服務，我們亦會定期進行進度評估並靈活調整計劃，確保長者在熟悉的環境中尊嚴生活。"
}];
export default function OnzeWerkwijze() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="104921" id="服務流程圖" className="bg-background py-16 md:py-24 overflow-hidden" ref={sectionRef}>
      <div className={`container mx-auto px-4 md:px-6 max-w-6xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-primary mb-4">
            服務流程圖
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            清晰透明的四步流程，為您的家人提供專業、窩心且個人化的居家醫護支援。
          </p>
        </div>

        {}
        <div className="md:hidden">
          <Accordion type="single" collapsible className="w-full">
            {steps.map((step, i) => <AccordionItem key={step.id} value={step.id} data-index={i}>
                <AccordionTrigger className="hover:no-underline py-6">
                  <div className="flex items-center gap-4 text-left">
                    <span className="text-3xl font-serif text-primary/30">
                      {step.id}
                    </span>
                    <span className="text-xl font-serif text-primary">
                      {step.title}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                  {step.description}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        {}
        <div className="hidden md:block relative mt-12">
          {}
          <div className="absolute top-[2.25rem] left-[12.5%] right-[12.5%] h-[2px] border-t-2 border-dotted border-primary/20 -z-10" aria-hidden="true" />

          <div className="grid grid-cols-4 gap-8">
            {steps.map((step, i) => <div key={step.id} data-index={i} className="flex flex-col items-center text-center group">
                <div className="bg-background px-6 inline-block transition-transform duration-500 group-hover:scale-110">
                  <span className="text-6xl lg:text-7xl font-serif text-primary/20 drop-shadow-xl transition-colors duration-300 group-hover:text-primary/40">
                    {step.id}
                  </span>
                </div>
                <h3 className="text-2xl font-serif text-primary mt-8 mb-4">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed text-sm lg:text-base px-2">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}